import {
    postPrivacyPolicyRepo, getPrivacyPolicyRepo 
} from "../repositories/statisPages"
import { createSlice } from "@reduxjs/toolkit";

const staticPagesSlice = createSlice({
    name: "staticPagesReducer",
    initialState: {
        privacyPolicyDataLoading: false,
        privacyPolicyData: null,
        privacyPolicyDataError: null,

        postPrivacyPolicyLoading: false,
        postPrivacyPolicyData: null,
        postPrivacyPolicyError: null,

        termsAndConditionDataLoading :false,
        termsAndConditionData : null,
        teamsAndConditionDataError :null,

        postTermsAndConditionLoading : false,
        postTermsAndConditionData : null,
        postTermsAndConditionError : null,

        message:null,

       },
    reducers: {

        getPrivacyPolicyLoading(state, action) {
            
            return {
                ...state,
                privacyPolicyDataLoading: true,
            };
        },
        getPrivacyPolicySuccess(state, action) {
            return {
                ...state,
                privacyPolicyDataLoading: false,
                privacyPolicyData: action.payload,
            };
        },
        getPrivacyPolicyFailure(state, action) {
            return {
                ...state,
                privacyPolicyDataLoading: false,
                privacyPolicyDataError: action.payload,
            };
        },

        clearGetPrivacyPolicyReponse(state, action) {
            return {
                ...state,
                privacyPolicyData: null,
                privacyPolicyDataError: null,
            };
        },

        postPrivacyPolicySuccess(state, action) {
            return {
                ...state,
                postPrivacyPolicyLoading: false,
                postPrivacyPolicyData: action.payload,
            };
        },
        postPrivacyPolicyFailure(state, action) {
            return {
                ...state,
                postPrivacyPolicyLoading: false,
                postPrivacyPolicyError: action.payload,
            };
        },
        clearPostPrivacyPolicyResponse(state, action) {
            return {
                ...state,
                postPrivacyPolicyData: null,
                postPrivacyPolicyError: null
            }
        },
        getTermsAndConditionLoading(state, action) {
            return {
               ...state,
               termsAndConditionLoading:true,
            };
        },
       getTermsAndConditionSuccess(state, action) {
            return {
                ...state,
                termsAndConditionDataLoading:false,
                termsAndConditionData : action.payload,
              };
        },
        getTermsAndConditionFailure(state, action) {
            return {
                ...state,
                termsAndConditionDataLoading :false,
                teamsAndConditionDataError :action.payload,
                message:action.payload
            };
        },
        clearGetTermsAndConditionReponse(state, action) {
            return {
                ...state,
                termsAndConditionData : null,
                teamsAndConditionDataError :null,
                message:null
            };
        },
        postTermsAndConditionSuccess(state, action) {
            return {
                ...state,
                postTermsAndConditionLoading : false,
                postTermsAndConditionData : action.payload,
                message:"terms and conditions updated successfully"
            };
        },
        postTermsAndConditionFailure(state, action) {
            return {
                ...state,
                postTermsAndConditionLoading: false,
                postTermsAndConditionError: action.payload,
                message:action.payload
            };
        },
        clearPostTermsAndConditionResponse(state, action) {
            return {
                ...state,
                postTermsAndConditionData : null,
                postTermsAndConditionError : null,
                message:null,
            }
        },

         clearMessage(state, action) {
            return {
                ...state,
                message:null,
                postTermsAndConditionError : null,
                teamsAndConditionDataError :null,
            }
        },
       
    },
});
export const {
    getPrivacyPolicyLoading,
    getPrivacyPolicySuccess,
    getPrivacyPolicyFailure,
    clearGetPrivacyPolicyReponse,

    postPrivacyPolicySuccess,
    postPrivacyPolicyFailure,
    clearPostPrivacyPolicyResponse,

    getTermsAndConditionLoading,
    getTermsAndConditionSuccess,
    getTermsAndConditionFailure,
    clearGetTermsAndConditionReponse,

    postTermsAndConditionSuccess,
    postTermsAndConditionFailure,
    clearPostTermsAndConditionResponse,
    
    clearMessage,

} = staticPagesSlice.actions;

export const getPrivacyPolicy = (params) => {
    return async (dispatch) => {
        dispatch(getPrivacyPolicyLoading());
        await getPrivacyPolicyRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getPrivacyPolicySuccess(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getPrivacyPolicyFailure(error.message));
                }
            });
    };
};

export const postPrivacyPolicy = (params) => {
    return async (dispatch) => {
        await postPrivacyPolicyRepo(params)
            .then((response) => {
                if (
                    response?.status == 200 ||
                    response?.status == 201 ||
                    response?.status == 301
                ) {
                    dispatch(postPrivacyPolicySuccess(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(postPrivacyPolicyFailure(error.message));
                }
            });
    };
};

export const getTermsAndCondition = (params) => {
    return async (dispatch) => {
        dispatch(getTermsAndConditionLoading());
        await getPrivacyPolicyRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getTermsAndConditionSuccess(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getTermsAndConditionFailure(error.response?.data));
                }
            });
    };
};

export const postTermsAndCondition = (params) => {
    return async (dispatch) => {
        await postPrivacyPolicyRepo(params)
            .then((response) => {
                if (
                    response?.status == 200 ||
                    response?.status == 201 ||
                    response?.status == 301
                ) {
                    dispatch(postTermsAndConditionSuccess(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(postTermsAndConditionFailure(error.message));
                }
            });
    };
};









export default staticPagesSlice.reducer;